<template>
  <div class="hello">
    <info-box v-bind:description="description"></info-box>
  </div>
</template>

<script>
export default {
  name: 'hello',
  created: function () {

  },
  data () {
    return {
      description: {
        title: 'hello!',
        text: 'this is just a test'
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue